<template>
  <div class="modal" v-if="feedback.campaignID">
    <v-dialog :value="value" @input="$emit('input')" fullscreen content-class="client-feedback-view-dialog" transition="fade-transition">
      <v-card tile>
        <v-toolbar
          class="mb-12"
          color="secondary"
          elevate-on-scroll>
          <v-toolbar-title class="headline">Kobe Feedback Form</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container class="view-feedback-container ims-modal-body" fluid>
          <v-form ref="feedbackform" v-model="valid" lazy-validation>
          <v-layout wrap justify-center mb-2>
            <v-flex xs12 md7>
              <v-row>
                <v-col cols="6">
                  <label>{{feedbackFormSections.account_manager.title}}</label>
                  <p>{{feedback.accountManager}}</p>
                </v-col>
                <v-col cols="6">
                  <label>{{feedbackFormSections.client_name.title}}</label>
                  <p>{{feedback.clientName}}</p>
                </v-col>
                <v-col cols="6">
                  <label>{{feedbackFormSections.content_curator.title}}</label>
                  <p>{{feedback.CO}}</p>
                </v-col>
                <v-col cols="6">
                  <label>Campaign Name</label>
                  <p>{{feedback.campaignName}}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p class="subtitle-1 font-weight-bold mb-0">Your feedback helps decide what improvements should be made and what new features to work on in the future.</p>
                  <p class="subtitle-1 mb-0">We would like to take this opportunity to find out your experience working with Kobe.</p>
                  <p class="subtitle-1 mb-0">This form will take you 5 minutes to complete.</p>
                  <p class="subtitle-1 mb-0">Thank you for your time.</p>
                </v-col>
              </v-row>

              <!-- <v-row>
                <v-col>
                  <label>{{feedbackFormSections.campaign_name.title}}</label>
                  <p>{{feedback.campaignName}}</p>
                </v-col>
              </v-row> -->

              <v-row>
                <v-col>
                  <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                          <tr v-for="prop in feedbackFormSections.good_ratings.fields" :key="prop.key" :class="prop.class" height="60">
                            <td class="text-left pt-3">
                              <label>{{ prop.title }}</label>
                              <p>{{feedbackFormSections.good_ratings.values.find(v => v === feedback[prop.name])}}</p>
                            </td>
                          </tr>
                        </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <!-- <v-row class="mb-4">
                <v-col>
                  <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                          <tr v-for="prop in feedbackFormSections.satisfy_ratings.fields" :key="prop.key" :class="prop.class">
                            <td class="text-left pt-3">
                              <label>{{ prop.title }}</label>
                              <p>{{feedbackFormSections.satisfy_ratings.values.find(v => v === feedback[prop.name])}}</p>
                            </td>
                          </tr>
                        </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row> -->

              <!-- <v-row>
                <v-col>
                  <label>{{feedbackFormSections.services_appeals.title}}</label>
                  <v-layout wrap>
                    <v-flex xs12 md4 v-for="s in feedbackFormSections.services_appeals.fields.filter(v => feedback[feedbackFormSections.services_appeals.name].includes(v.value))" :key="s.key">
                      <p>{{s.label}}</p>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row> -->

              <v-row class="mb-4">
                <v-col>
                  <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                          <tr class="background-soft-grey" v-for="(item, index) in feedbackFormSections.likely_recommend.fields" :key="index">
                            <td class="text-left pt-3">
                              <label>{{item.title}}</label>
                              <p>{{feedback[item.name]}} / 10</p>
                            </td>
                          </tr>
                        </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                          <tr class="background-soft-grey" v-for="(item, index) in feedbackFormSections.likely_consider_again.fields" :key="index">
                            <td class="text-left pt-3">
                              <label>{{item.title}}</label>
                              <p>{{feedback[item.name]}} / 10</p>
                            </td>
                          </tr>
                        </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <label>{{feedbackFormSections.buyagain_decision.title}}</label>
                  <v-layout wrap>
                    <v-flex xs12 md6 v-for="b in feedbackFormSections.buyagain_decision.fields.filter(v => feedback[feedbackFormSections.buyagain_decision.name].includes(v.value))" :key="b.key">
                      <p>{{b.label}}</p>
                    </v-flex>
                    <v-flex xs12 md6 v-for="(other,i) in filterOtherBuyAgain()" :key="i">
                      <p>{{other}}</p>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <label>{{feedbackFormSections.what_did_well.title}}</label>
                  <p>{{feedback[feedbackFormSections.what_did_well.name]}}</p>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <label>{{feedbackFormSections.what_can_improve.title}}</label>
                  <p>{{feedback[feedbackFormSections.what_can_improve.name]}}</p>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <label>{{feedbackFormSections.account_manager_status.title}} {{feedback.accountManager}} is</label>
                  <v-layout wrap>
                    <v-flex xs12 md12 v-for="b in feedbackFormSections.account_manager_status.fields" :key="b.key">
                      <label>{{b.label}}</label>
                      <p>{{feedback[b.name]}} / 4</p>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <v-layout wrap>
                    <v-flex xs12 md12 v-for="b in feedbackFormSections.inf_line_up.fields" :key="b.key">
                      <label>{{b.label}}</label>
                      <div class="radio-section" v-for="(value, index) in feedbackFormSections.inf_line_up.values" :key="index">
                        <v-radio-group v-model="feedback[b.name]" hide-details required>
                          <span class="pr-1">{{index + 1}}.</span>
                          <v-radio :value="value" :label="value" disabled></v-radio>
                        </v-radio-group>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <v-layout wrap>
                    <v-flex xs12 md12 v-for="b in feedbackFormSections.inf_content_created.fields" :key="b.key">
                      <label>{{b.label}}</label>
                      <div class="radio-section" v-for="(value, index) in feedbackFormSections.inf_content_created.values" :key="index">
                        <v-radio-group v-model="feedback[b.name]" hide-details required>
                          <span class="pr-1">{{index + 1}}.</span>
                          <v-radio :value="value" :label="value" disabled></v-radio>
                        </v-radio-group>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <v-layout wrap>
                    <label>{{feedbackFormSections.sea_countries.title}}</label>
                    <v-flex xs12 md12 v-for="b in feedback[feedbackFormSections.sea_countries.name]" :key="b.key">
                      <p>{{b}}</p>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <v-layout wrap>
                    <label>{{feedbackFormSections.platforms.title}}</label>
                    <v-flex xs12 md12 v-for="b in feedback[feedbackFormSections.platforms.name]" :key="b.key">
                      <p>{{b}}</p>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <!-- <v-row>
                <v-col>
                  <label>{{feedbackFormSections.what_you_tell_about_kobe.title}}</label>
                  <p>{{feedback[feedbackFormSections.what_you_tell_about_kobe.name]}}</p>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <label>{{feedbackFormSections.what_one_word_in_mind_about_kobe.title}}</label>
                  <p>{{feedback[feedbackFormSections.what_one_word_in_mind_about_kobe.name]}}</p>
                </v-col>
              </v-row> -->

              <!-- <v-row class="mb-4">
                <v-col>
                  <label>{{feedbackFormSections.kobe_connect.title}}</label>
                  <div v-for="(k, index) in feedbackFormSections.kobe_connect.fields" :key="index">
                    <p>{{k.label}}. {{feedback[k.name]}}</p>
                  </div>
                </v-col>
              </v-row> -->

              <!-- <v-row class="mb-4">
                <v-col>
                  <label>{{feedbackFormSections.marketing_challenges.title}}</label>
                  <v-layout wrap>
                    <v-flex xs12 md6 v-for="b in feedbackFormSections.marketing_challenges.fields.filter(v => feedback[feedbackFormSections.marketing_challenges.name].includes(v.value))" :key="b.key">
                      <p>{{b.label}}</p>
                    </v-flex>
                    <v-flex xs12 md6 v-for="(other, index) in filterMarketingChallenge()" :key="index">
                      <p>{{other}}</p>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row> -->

              <v-row>
                <v-col cols="12" v-for="(kobe, index) in feedbackFormSections.kobe_questions.fields" :key="index" v-if="feedback[kobe.name]">
                  <label>{{kobe.label}}</label>
                  <p>{{feedback[kobe.name]}}</p>
                </v-col>
              </v-row>
              
              <v-row class="mb-4">
                <v-col>
                  <p class="font-weight-bold mb-3">{{feedbackFormSections.refer_info.title}}</p>
                  <v-layout wrap>
                    <v-flex xs12 md6 v-for="(contact, index) in feedbackFormSections.refer_info.fields" :key="index">
                      <div>
                        <label>{{contact.label}}</label>
                        <p>{{feedback[contact.name] || '-'}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" v-if="feedback.scheduleSharing === true || feedback.scheduleSharing === false">
                  <div>
                    <v-icon color="green" size="20" v-if="feedback.scheduleSharing === true">mdi-check</v-icon>
                    <v-icon color="danger" size="20" v-if="feedback.scheduleSharing === false">mdi-close-circle</v-icon>
                    I would like for Kobe to schedule an internal sharing for the rest of my business teams
                  </div>
                </v-col>
              </v-row>

              <v-row class="mb-4">
                <v-col>
                  <v-layout wrap>
                    <v-flex xs12 md6 v-for="(contact, index) in feedbackFormSections.contact_info.fields" :key="index">
                      <div>
                        <label>{{contact.label}}</label>
                        <p>{{feedback[contact.name] || '-'}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import clientConfig from './clientConfig.js';
export default {
  name: 'ViewFeedbackModal',
  props: {
    value: Boolean,
    feedbackData: Object
  },
  data () {
    return {
      feedbackFormSections: clientConfig.feedbackFormSections,
      feedback: {}
    }
  },
  computed: {
    currentUserID: function() {
      return this.$store.state.user.id;
    }
  },
  methods: {
    close() {
      this.$emit('input');
    },
    filterOtherBuyAgain() {
      let values = this.feedback[this.feedbackFormSections.buyagain_decision.name]
      let buyAgainDecisions = new Set(this.feedbackFormSections.buyagain_decision.fields.map(({ value }) => value))
      return values.filter(v => !buyAgainDecisions.has(v))
    },
    filterMarketingChallenge() {
      let values = this.feedback[this.feedbackFormSections.marketing_challenges.name]
      let marketingChallenges = new Set(this.feedbackFormSections.marketing_challenges.fields.map(({ value }) => value))
      return values.filter(v => !marketingChallenges.has(v))
    }
  },
  watch: {
    feedbackData: function(newfeedbackData) {
      this.feedback = newfeedbackData
    }
  }
}
</script>
<style>
  .v-dialog.v-dialog--fullscreen.client-feedback-view-dialog {
    overflow: hidden;
  }

  .view-feedback-container .radio-section .v-input--radio-group__input {
    display: flex;
    flex-direction: row;
  }
  .schedule-sharing-chk .v-label--is-disabled {
    font-weight: bold!important;
  }
</style>
<style scoped>
  .background-soft-grey {
    background-color: #f6f6f6;
  }

  .v-text-field-sm{
    width: 320px;
  }

  .td-error {
    margin-bottom: -20px;
    right: 16px;
  }

  .checkboxes-error {
    margin-top: -15px;
  }

  .td-title {
    font-weight: bold;
    margin-bottom: 1px;
  }
</style>



// WEBPACK FOOTER //
// ViewFeedbackModal.vue?87433324